// extracted by mini-css-extract-plugin
module.exports = {"likeButton":"LikeButton_likeButton__sGS5M","likeButtonInverted":"LikeButton_likeButtonInverted__6I9_D","likeButtonIcon":"LikeButton_likeButtonIcon__7NnIl"};